module.exports = __webpack_public_path__ + "img/Deadline.ec9d4ac0.svg";